import { useLang } from "../lib/i18n";
import { LogoMark } from "./Logo";

export const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <section data-testid="editorial-marquee" className="bg-[#F6F2EC] border-y border-[#ddd4c7] py-8 sm:py-10 overflow-hidden">
      <div className="flex w-max marquee-track">
        {items.map((m, i) => (
          <div key={i} className="flex items-center gap-10 sm:gap-16 pr-10 sm:pr-16">
            <span className={`font-serif-d font-light text-4xl sm:text-6xl whitespace-nowrap ${i % 2 ? "italic text-[#8A6A3A]" : "text-[#14110F]"}`}>{m}</span>
            <LogoMark className="w-6 h-8 shrink-0" color="#14110F" accent="#C9A66B" />
          </div>
        ))}
      </div>
    </section>
  );
};
